import React, { useState } from 'react';
import OrderSummary from '../../Common/Ordersummary';

const NewAddress = () => {
  const [formData, setFormData] = useState({

    mobilenumber: '',
    pincode: '',
    locality: '',
    state: '',
    address: '',
    city: '',
  });

  const [phoneNumber, setPhoneNumber] = useState('');
  const [pincode, setPincode] = useState('');
  const [locality, setLocality] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhoneNumber(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form data submitted:', formData);
  };

  return (
    <div className="p-4 md:mt-60">
      <div className="flex flex-col md:flex-row gap-5 md:ml-28">
        <div className="md:w-2/4">
          <div className="shadow-md border border-gray-300 p-5 bg-white mb-5 rounded-2xl">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="font-bold text-2xl">DELIVERY ADDRESS</h1>
                <br />
                <h3 className="font-bold text-xl">EDIT ADDRESS</h3>
                <br />

                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 md:grid-cols-2 md:gap-32 mt-4">
                    <div>
                      <label htmlFor="mobilenumber" className="block text-sm font-medium text-gray-700 w-full">
                        Mobile Number
                      </label>
                      <input
                        type="number"
                        id="mobilenumber"
                        value={phoneNumber}
                        onChange={handleInputChange}
                        className="mt-2 block md:w-72 px-4 py-3 border border-gray-500 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="Mobile Number"
                      />
                    </div>
                    <div>
                      <label htmlFor="pincode" className="block text-sm font-medium text-gray-700 w-full">
                        Pincode
                      </label>
                      <input
                        type="text"
                        id="pincode"
                        value={pincode}
                        onChange={(e) => setPincode(e.target.value)}
                        className="mt-2 block md:w-72 px-4 py-3 border border-gray-500 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="Pincode"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 md:gap-32 mt-4">

                    <div>
                      <label htmlFor="locality" className="block text-sm font-medium text-gray-700 w-full">
                        Locality
                      </label>
                      <input
                        type="text"
                        id="locality"
                        value={locality}
                        onChange={(e) => setLocality(e.target.value)}
                        className="md:mt-2 block md:w-72 px-4 py-3 border border-gray-500 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="Locality"
                      />
                    </div>
                    <div>
                      <label htmlFor="state" className="block text-sm font-medium text-gray-700 w-full">
                        State
                      </label>
                      <input
                        type="text"
                        id="state"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        className="mt-2 block md:w-72 px-4 py-3 border border-gray-500 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="State"
                      />
                    </div>
                  </div>


                  <div className="grid grid-cols-1 md:grid-cols-1 md:gap-32 mt-4">
                    <div>
                      <label htmlFor="address" className="block text-sm font-medium text-gray-700 w-full">
                        Address
                      </label>
                      <input
                        type="text"
                        id="address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        className="mt-2 block md:w-full px-4 py-3 border border-gray-500 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="Address"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 md:gap-32 mt-4">
                    <div>
                      <label htmlFor="city" className="block text-sm font-medium text-gray-700 w-full">
                        City
                      </label>
                      <input
                        type="text"
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className="mt-2 block md:w-72 px-4 py-3 border border-gray-500 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="City"
                      />
                    </div>

                  </div>

                  <div className="flex justify-start mt-5">
                    <button type="submit" className="bg-[#FF0004] text-white px-10 py-3 rounded hover:bg-red-700">
                      Save and Delivery Here
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="shadow-md border border-gray-300 p-5 bg-white mb-5 rounded-2xl flex justify-between items-center">
            <a href="/AddAddress">
              <span className="px-4 py-2 rounded-full flex text-blue-500 items-center">
                <span className="text-2xl font-bold mr-1">+ Add a new address</span>
              </span>
            </a>
          </div>
        </div>

        <OrderSummary />
      </div>
    </div>
  );
};

export default NewAddress;
